import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/employee-allowance";

//#region state
const state = {
  listEmployeeAllowance: [],
  employeeAllowance: {},
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        route.push({ name: "Detail Employee Allowance", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createByDepartment(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/department`, body);
      if (response.status === 200) {
        route.push({ name: "Employee Allowance" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async delete(context, id) {
    try {
      const response = await api.deleted(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        route.push({ name: "Employee Allowance" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(BASE_URL);
      if (response.status === 200) {
        context.commit("SET_EMPLOYEE_ALLOWANCES", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLimit(context, employeeId) {
    try {
      const response = await api.get(`${BASE_URL}/limit/${employeeId}`);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        context.commit("SET_EMPLOYEE_ALLOWANCE", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_EMPLOYEE_ALLOWANCES(state, payload) {
    state.listEmployeeAllowance = payload;
  },
  SET_EMPLOYEE_ALLOWANCE(state, payload) {
    state.employeeAllowance = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
